"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.InfoIcon = function (props) {
    return (React.createElement("svg", { id: props.id + "-info-icon", "data-qa": "info-icon", width: "16", height: "16", viewBox: "0 0 16 16" },
        React.createElement("g", { fill: "#CACDD1" },
            React.createElement("path", { d: "M8 14.5A6.5 6.5 0 1 1 14.5 8 6.51 6.51 0 0 1 8 14.5zM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm1 3.5v2H7v-2h2zm0 4v5H7v-5h2z" }))));
};
